<!-- <p>dashboard-events works!</p> -->
<div class="main-div" #main>
    <div class="title-tabs">
        <div class="title">
            <span>{{panelData ? panelData.title : "Events"}}</span>
            <mat-icon *ngIf="creating && panelData" [matMenuTriggerFor]="titleMenu"
                [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
        </div>
        <ejs-tab style="height: 100%;" #tabs id="element" (selecting)="tabChange($event)">
            <e-tabitems>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>rule</mat-icon>&nbsp;Rule Events
                    </ng-template>
                    <ng-template #content>
                        <div class="rule-event">
                            <span>Timestamp</span>
                            <span>Rule</span>
                            <span style="margin: auto;">Acknowledged</span>
                        </div>
                        <div class="listbox-wrapper">
                            <ejs-listbox class="listbox" [dataSource]='filteredRuleEvents' [fields]="ruleEventFields">
                                <ng-template #itemTemplate let-data>
                                    <div class="rule-event ejs-listbox-item" (click)="goToRuleEvent(data)">
                                        <span>{{convertEpochToShortDate(data.TimeStamp)}}</span>
                                        <span>{{data.RuleName}}</span>
                                        <mat-icon style="margin: auto;"
                                            [ngStyle]="{'color': data.Acknowledged ? 'lightgreen' : 'salmon'}">{{data.Acknowledged
                                            ? 'done' : 'close'}}</mat-icon>
                                    </div>
                                </ng-template>
                            </ejs-listbox>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>sensors_off</mat-icon>&nbsp;Sensor Offline Events
                    </ng-template>
                    <ng-template #content>
                        <div class="sensor-event">
                            <span>Timestamp</span>
                            <span>Sensor</span>
                            <span style="margin: auto;">Acknowledged</span>
                        </div>
                        <div class="listbox-wrapper">
                            <ejs-listbox class="listbox" [dataSource]='filteredSensorEvents'
                                [fields]="sensorEventFields">
                                <ng-template #itemTemplate let-data>
                                    <div class="sensor-event ejs-listbox-item" (click)="goToOfflineEvent(data)">
                                        <span>{{convertEpochToShortDate(data.TimeStamp)}}</span>
                                        <span>{{data.SensorName}}</span>
                                        <mat-icon style="margin: auto;"
                                            [ngStyle]="{'color': data.Acknowledged ? 'lightgreen' : 'salmon'}">{{data.Acknowledged
                                            ? 'done' : 'close'}}</mat-icon>
                                    </div>
                                </ng-template>
                            </ejs-listbox>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>insights</mat-icon>&nbsp;Deviation Events
                    </ng-template>
                    <ng-template #content>
                        <div class="deviation-event">
                            <span>Timestamp</span>
                            <span>Asset</span>
                            <span style="margin: auto;">Acknowledged</span>
                        </div>
                        <div class="listbox-wrapper">
                            <ejs-listbox class="listbox" [dataSource]='filteredDeviationEvents'
                                [fields]="deviationEventFields">
                                <ng-template #itemTemplate let-data>
                                    <div class="deviation-event ejs-listbox-item" (click)="goToDeviationEvent(data)">
                                        <span>{{convertEpochToShortDate(data.Timestamp)}}</span>
                                        <span>{{data.AssetName}}</span>
                                        <mat-icon style="margin: auto;"
                                            [ngStyle]="{'color': data.Acknowledged ? 'lightgreen' : 'salmon'}">{{data.Acknowledged
                                            ? 'done' : 'close'}}</mat-icon>
                                    </div>
                                </ng-template>
                            </ejs-listbox>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem>
                    <ng-template #headerText>
                        <mat-icon>webhook</mat-icon>&nbsp;Webhook Events
                    </ng-template>
                    <ng-template #content>
                        <div class="webhook-event">
                            <span>Timestamp</span>
                            <span>Webhook</span>
                            <span>Text</span>
                        </div>
                        <div class="listbox-wrapper">
                            <ejs-listbox class="listbox" [dataSource]='filteredWebhookEvents'
                                [fields]="webhookEventFields">
                                <ng-template #itemTemplate let-data>
                                    <div class="webhook-event ejs-listbox-item" (click)="goToWebhookEvent(data)">
                                        <span>{{convertEpochToShortDate(data.TimeStamp)}}</span>
                                        <span>{{data.Description}}</span>
                                        <span>{{data.WebhookEventText}}</span>
                                    </div>
                                </ng-template>
                            </ejs-listbox>
                        </div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</div>